import React, { useEffect, useState } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductDetails } from './components/ProductDetails';
import { Pricing } from './components/Pricing';
import { TrustAndFAQ } from './components/TrustAndFAQ';
import { Closing } from './components/Closing';
import { CHECKOUT_URL } from './components/Shared';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the first hero button (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-base text-dark font-montserrat selection:bg-payment selection:text-white" data-id="element-0" data-mp="23utb6267bya9">
      <Hero data-id="element-1" data-mp="3ijpet5g4t7bv" />
      <ProblemSolution data-id="element-2" data-mp="3ii4s22026sok" />
      <ProductDetails data-id="element-3" data-mp="3mlatmwc87vop" />
      <Pricing data-id="element-4" data-mp="3mkhn9wh6j873" />
      <TrustAndFAQ data-id="element-5" data-mp="3mjzs7369700r" />
      <Closing data-id="element-6" data-mp="3mjg8bgx1m1k3" />

      <PurchasePopup data-id="element-7" data-mp="3rc9e8848zfxr" />

      {/* Mobile Sticky CTA */}
      <div className={`fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-4 z-40 md:hidden transition-transform duration-300 ease-in-out shadow-[0_-4px_10px_rgba(0,0,0,0.05)] ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-8" data-mp="3rcsxpt9jqcdw">
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => {
        const fbq = (window as any).fbq;
        if (typeof fbq === 'function') fbq('track', 'InitiateCheckout');
      }} className="block w-full rounded-xl bg-payment px-4 py-4 text-center font-montserrat font-bold uppercase tracking-wider text-white shadow-[0_6px_0_#008DBD] transition-transform active:translate-y-1 active:shadow-[0_2px_0_#008DBD]" data-id="element-9" data-mp="33m5ck6amdq9e">
          SÍ, QUIERO RESULTADOS ESTA SEMANA
        </a>
      </div>
    </div>;
}